// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/spring-testing/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const springTestingEN: PageEntry = {
  id: "post.federpruefung",
  locale: "en",
  slug: "spring-testing",
  seo: {
    title: "Glossary: Spring testing explained simply | Dietz GmbH",
    description: "Spring testing is the process by which springs are tested for their mechanical properties and their compliance with standards and specifications. This can be carried out using vari",
  },
  type: "post",
  h1: "Glossary: Spring testing explained simply",
  intro: "Spring testing is the process by which springs are tested for their mechanical properties and their compliance with standards and specifications. This can be carried out using various test methods such as load tests, hardness tests or non-destructive tests. Spring testing is critical to ensure that springs meet the requirements of their specific application and perform as required. Quality control and test certificates are common results of spring testing, ensuring the reliability and safety of springs in various industries.",
  blocks: [

  ],
};
